import { PlusIcon } from "@xola/icons";
import clsx from "clsx";
import React from "react";

interface ManageActionButtonProps {
    text: string;
    disabled?: boolean;
    onClick?: () => void;
}

// TODO: Rename to something generic.
export const ManageActionButton = ({ text, disabled = false, onClick }: ManageActionButtonProps) => {
    return (
        <button
            type="button"
            disabled={disabled}
            className={clsx(
                "mt-1 flex cursor-pointer items-center text-sm font-bold leading-p1 text-black hover:underline",
                disabled && "pointer-events-none !text-gray",
            )}
            onClick={onClick}
        >
            <PlusIcon className="mr-1 rounded-sm border border-gray px-0.5 text-black" /> {text}
        </button>
    );
};
